import * as React from 'react';
import { createFormatters, parseAsDateUTC } from 'app/infrastructure/data/date';
import { Link } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { tableName } from 'app/area/case/case-data-model';
import { sectionFor } from 'app/area/case/components/fact-box/constants';
import { SectionLink } from 'app/area/case/components/fact-box/types';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { DisplayNumberProps } from 'ui/display-number/display-number';
import { DisplayDateProps } from 'ui/display-date/display-date';
import styles from './previous-values-item.scss';

interface PreviousValuesItemProps {
  amount: number;
  unitOfMeasure: string;
  caseNo: number;
  periodStart: string;
  periodEnd: string;
  greenNo: number;
  substanceCategory: string;
  locale: string;
  textDetailsAmount: string;
  textDetailsPeriodStart: string;
  textDetailsPeriodEnd: string;
}

type DisplayPreviousValuesItemProps = PreviousValuesItemProps & SectionLink & DisplayNumberProps & DisplayDateProps;
export const PreviousValuesItem = (props: DisplayPreviousValuesItemProps) => {
  
  const formatters = createFormatters(props.locale);
  const { textDetailsAmount, textDetailsPeriodStart, textDetailsPeriodEnd,
    amount, unitOfMeasure, caseNo, periodStart, periodEnd, greenNo, substanceCategory } = props;

  const dateIntlOptions = { 
    weekday: props.weekdayFormat || 'long', 
    day: props.dayFormat || 'numeric',
    month: props.monthFormat || 'long',
    year: props.yearFormat || 'numeric'
  };   
  const formattedPeriodStart = formatters.formatDate(parseAsDateUTC(periodStart), dateIntlOptions);
  const formattedPeriodEnd = formatters.formatDate(parseAsDateUTC(periodEnd), dateIntlOptions);
  
  const formattedAmount = amount && new Intl.NumberFormat(props.locale, {useGrouping: props.useThousand, 
    maximumFractionDigits: props.maxDecimals}).format(amount);

  const section= sectionFor(props, tableName.green);
  const { itemsWrapper, item, value, itemLink, header } = styles;
  
  return (
    <div className={`${itemsWrapper} row`}>
      <div className={`${item} col-lg-12`}>
        <Link url={toAbsoluteUrl(routeConstants.caseSectionFor(caseNo, section))} className={`${itemLink}`}>
          <h2 className={header}>#{caseNo} - {substanceCategory} #{greenNo}</h2>
        </Link>
      </div>
      <div className={`${item} col-lg-12`}>
        <label className="label">{textDetailsPeriodStart} - {textDetailsPeriodEnd}</label>
        <div className={value}>{formattedPeriodStart} - {formattedPeriodEnd}</div>
      </div>
      <div className={`${item} col-lg-12`}>
        <label className="label">{textDetailsAmount}</label>
        <div className={value}>{formattedAmount} {unitOfMeasure}</div>
      </div>
    </div>
  );
};
